import React, { Component } from 'react'


class User extends Component {
  
    formatDate(date, isDateTime) {
        if(!date)
            return ""
        return new Intl.DateTimeFormat("de-DE", isDateTime ? {
            year: "numeric",
            month: "numeric",
            day: "2-digit", 
            hour:  "2-digit",
            minute: "2-digit",
            second: "2-digit"
        } : {
            year: "numeric",
            month: "numeric",
            day: "2-digit", 
        }).format(new Date(date))
    }

    constructor(props) {
      super(props);
      // Don't call this.setState() here!
      this.state = props.user;
    }

  render() {
    let user = this.props.user
    let columns = this.props.columns
    let locked = this.props.locked
    
    let elements = React.Children.toArray(this.props.children)
    let updateButton
    if(elements.length === 1){
        updateButton = React.cloneElement(elements[0], {id: this.state.id, state: this.state})
    }

    let tableData = []
    for(let [column, columnAttributes] of Object.entries(columns)) {
        let type = columnAttributes.type
        let key = `${user.id}_${column}`

        let valueInString = user[column]
        if(column.includes(".")) {
            var subAttributes = column.split(".")
            let userPart = user
            for(let subAttribute of subAttributes) {
                if(userPart[subAttribute]) {
                    userPart = userPart[subAttribute]
                } else {
                    userPart = null
                    break;
                }
            }
            valueInString = userPart
        }
        if(type === "boolean") {
            valueInString = valueInString ? "True" : "False"
        } else if(type === "date") {

        }
        if(!valueInString) {
            valueInString = this.formatDate(valueInString, true)
        }
        let child
        if(!locked && columnAttributes.isEditAble) {
            child = <input
                value={valueInString}
                onChange={e => {
                    let value = e.target.value ?? ""
                    if(columnAttributes.type === "number") {
                        value = Number.parseInt(value)
                    }
                    user[column] = value
                    this.setState({user: user})
                }}
                type={columnAttributes.type ?? "text"}
                placeholder={column}
            />
        }
        tableData.push((<td key={key}>{ child ?? valueInString }</td>))
    }

    return (
        <tr>
            {tableData}
            {!locked && <td>{ updateButton }</td>}
        </tr>
        )
    } 

}

export default User